/**
 * The copyright line.
 *
 * One component so the login screen and the app shell carry the same words and
 * the same link - it is a legal line, not something to let drift between two
 * copies.
 *
 * `tone` follows the ground it sits on: the login screen is the dark gradient,
 * the shell is the light slate of the working screens.
 */

import posLogo from '../../assets/POS_Logo.jpeg';

export const COMPANY_URL = 'https://ast.com.pk/';

const TONES = {
    light: { text: 'text-slate-500', link: 'text-brand-700 hover:text-brand-900' },
    dark: { text: 'text-white/60', link: 'text-white/90 hover:text-white' }
};

const AppFooter = ({ tone = 'light', className = '' }) => {
    const colors = TONES[tone] || TONES.light;

    return (
        <footer
            className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center
                        text-[11px] leading-tight ${colors.text} ${className}`}
        >
            {/* The artwork is a square file with its mark in the middle band,
                so it is cropped to that band rather than shrunk whole. */}
            <img
                src={posLogo}
                alt="Awami POS"
                className="h-5 w-9 shrink-0 rounded-sm bg-white object-cover"
            />
            <span>
                All rights reserved © Copyright{' '}
                <a
                    href={COMPANY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`font-semibold underline-offset-2 hover:underline ${colors.link}`}
                >
                    Awami Systems Technologies (Pvt) Ltd.
                </a>
                {' '}2026
            </span>
        </footer>
    );
};

export default AppFooter;
